module.exports = __webpack_public_path__ + "media/1x1/pl-3fe3bd51.svg";